import { Week } from "app/models/week"

export enum Types {
  GET = "WEEKS_GET_WEEKS",
  GET_SUCCESS = "WEEKS_GET_WEEKS_SUCCESS",
  GET_FAIL = "WEEKS_GET_WEEKS_FAIL",
}

export type Action = GetWeeksAction | GetWeeksSuccessAction | GetWeeksFailAction

export type GetWeeksAction = {
  payload: { week: string }
  type: Types.GET
}

export type GetWeeksSuccessAction = {
  type: Types.GET_SUCCESS
  payload: { data: Week | undefined }
}

export type GetWeeksFailAction = {
  type: Types.GET_FAIL
  payload: { errors: object }
}

export function getWeeks(week: string): GetWeeksAction {
  return {
    payload: { week },
    type: Types.GET,
  }
}

export function getWeeksSuccess(data: Week | undefined): GetWeeksSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}
export function getWeeksFail(errors: object): GetWeeksFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}
